const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./item-fullcont-handler')
const {
	buildChatCardWarning,
	readFullcontField,
	friendlySectionName,
} = require('../../../../../components/chat/chat-card-warning')

export function start(detail) {
	if (obj[detail.act]) {
		obj[detail.act].start(detail)
	}
}

const obj = {
	load: { start: (detail) => { load(detail) } },
	submit: { start: (detail) => { submit(detail) } },
	typing: { start: (detail) => { typing(detail) } },
	beforeChat: { start: (detail) => { beforeChat(detail) } },
	loadAllItems: { start: (detail) => { loadAllItems(detail) } },
}

const INVENTORY_QUESTIONS = [
	'Items below minimum stock level?',
	'Items nearing expiration?',
	'Last adjustment?',
]

const ITEMS_QUESTIONS = [
	'Current price?',
	'Stock available?',
	'Last transaction?',
]

function getGeneralQuestions(type) {
	if (type === 'inventory') {
		return INVENTORY_QUESTIONS
	}

	if (type === 'item') {
		return ITEMS_QUESTIONS
	}
}

function loadAllItems(detail) {
	const cardWarning = buildChatCardWarning({
		entityDisplay: 'Products',
		typeLabel: 'General inventory view',
		recordId: '—',
		details: [
			{ label: 'What includes', value: 'Summary of many products at once (representative sample)' },
			{ label: 'Products', value: 'Several items; the assistant works with an extract, not with the complete catalog' },
			{ label: 'Your session', value: 'Only you see this conversation in your account' },
		],
		scopeNote:
			'The assistant uses aggregated inventory information. The answers may not be saved linked to a single product.',
	})

	chat.start({
		dest: 'chat',
		act: 'quickview',
		actQuickview: 'show',
		type: 'itemAll',
		entity: 'item',
		question: detail.question ?? '',
		generalQuestions: getGeneralQuestions('inventory'),
		cardWarning: cardWarning,
		ev: detail.ev,
	})
}

function load(detail) {
	const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
	const recordId = fullcontActivo.getAttribute('data-dbid')

	const details = fullcontActivo
		? [
				{ label: 'Code', value: readFullcontField(fullcontActivo, 'item_form_code') },
				{ label: 'Name', value: readFullcontField(fullcontActivo, 'item_form_name') },
				{ label: 'Brand', value: readFullcontField(fullcontActivo, 'item_form_brand') },
		  ]
		: []

	const cardWarning = buildChatCardWarning({
		entityDisplay: friendlySectionName(detail.dest),
		typeLabel: 'Saved product',
		recordId: recordId || '—',
		details,
		scopeNote:
			'The conversation and history correspond only to this product and to what has already been saved here.',
	})

	if (recordId) {
		chat.start({
			dest: 'chat',
			act: 'quickview',
			actQuickview: 'show',
			type: 'item',
			entity: 'item',
			question: detail.question ?? '',
			recordId: recordId,
			ev: detail.ev,
			generalQuestions: getGeneralQuestions('item'),
			cardWarning: cardWarning,
		})

		const msj = handler.getChatsFc()
		chat.start({
			dest: 'chat',
			act: 'load',
			chats: msj,
			generalQuestions: getGeneralQuestions('item'),
			cardWarning: cardWarning,
		})
	}
}

function beforeChat(detail) {
	const htmlFc = handler.getDataFc()
	const dataToSend = handler.getValuesForChat(detail, htmlFc)
	if (!dataToSend) return

	const fc = document.getElementById(`${detail.dest}-fullcont`)
	const details = fc
		? [
				{ label: 'Code', value: readFullcontField(fc, 'item_form_code') },
				{ label: 'Name', value: readFullcontField(fc, 'item_form_name') },
				{ label: 'Brand', value: readFullcontField(fc, 'item_form_brand') },
		  ]
		: [{ label: 'Status', value: 'Draft — the product has not been saved yet' }]

	const cardWarning = buildChatCardWarning({
		entityDisplay: friendlySectionName(detail.dest),
		typeLabel: 'Before saving',
		recordId: fc ? fc.getAttribute('data-dbid') || '—' : '—',
		details,
		scopeNote:
			'The assistant uses what you see on screen. If you have not saved, some answers may not be saved in the history.',
	})

	chat.start({
		dest: 'chat',
		act: 'quickview',
		actQuickview: 'show',
		type: 'itemBefore',
		entity: 'item',
		data: dataToSend,
		question: detail.question ?? '',
		ev: detail.ev,
		cardWarning: cardWarning,
	})
}

function submit(detail) {}

function typing(detail) {
	chatHandler.typing(detail)
}
